import { Link } from 'react-router-dom';

import { useUserInfo } from '#providers/UserInfo';
import { useGetCoachLectures } from '#api/lectures';
import { BoxIcon, Text } from '#atoms';

import * as S from './styles';

const LECTURE_TYPE: { [key: string]: string } = {
  isOnePoint: '원포인트',
  isOt: '체험수업',
  lecture: '정규'
};

export const LectureInfoList = () => {
  const { userInfo } = useUserInfo();

  const { data: lecturesData } = useGetCoachLectures(userInfo?.id ?? '');

  return (
    <S.Container>
      <S.LabelBox>
        <Text style={{ fontSize: '18px' }}>수업 정보</Text>
        <Link to="/profile/class/register">
          <BoxIcon type="plus-purple" onlyIcon size={20} />
        </Link>
      </S.LabelBox>
      <S.LectureList>
        {lecturesData
          ? lecturesData.data.map((lecture, index) => (
              <S.LectureCard key={index}>
                <Link to={`/profile/class/${lecture.id}`}>
                  <S.Text className="point">
                    {LECTURE_TYPE[lecture.lectureType]}
                  </S.Text>
                  <S.Text className="title">{lecture.title}</S.Text>
                  <S.Text className="description">{lecture.body}</S.Text>
                  <S.Price>
                    {lecture.price.toLocaleString('ko-KR')}원<span>/3회</span>
                  </S.Price>
                </Link>
              </S.LectureCard>
            ))
          : null}
      </S.LectureList>
    </S.Container>
  );
};
